import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ReactSelect from '../../ReactSelect/ReactSelect';
import { FormGroup } from 'ps-design';

export default class StructureList extends Component {
  static propTypes = {
    structureList: PropTypes.object,
    structureListChange: PropTypes.func,
    history: PropTypes.object,
    payStructure: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.state = { value: '' };
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (typeof nextState.value !== 'object' && nextProps.payStructure) {
      this.updateInitialFilter(nextProps.payStructure);
      return true;
    } else if (
      typeof nextState.value !== 'object' &&
      nextProps.structureList &&
      nextProps.structureList.jobStructureItems &&
      nextProps.structureList.jobStructureItems.default_structure
    ) {
      this.updateFilterSave(nextProps.structureList.jobStructureItems.default_structure);
      return true;
    }
    return true;
  }

  componentDidMount() {
    this.props.structureListChange({ structure: '', skipJobGradeReset: true });
  }

  updateFilterSave(value) {
    if (value) {
      this.setState({ value: value });
      this.props.structureListChange({ structure: value.value });
    }
  }

  updateInitialFilter(value) {
    if (value) {
      this.setState({ value: { value: value, label: value } });
      this.props.structureListChange({ structure: value, skipJobGradeReset: true });
    }
  }

  render() {
    const { structureList } = this.props;

    const payStructure =
      structureList && structureList.jobStructureItems && structureList.jobStructureItems.structure_list
        ? structureList.jobStructureItems.structure_list
        : [{ value: 'N/A', label: 'N/A' }];

    return (
      <FormGroup>
        <ReactSelect
          name="form-field-name"
          value={payStructure.filter(({ value }) => value === this.state.value.value)}
          options={payStructure}
          getOptionValue={option => option.value}
          getOptionLabel={option => option.label}
          onChange={this.updateFilterSave.bind(this)}
          clearable={Boolean(false)}
        />
      </FormGroup>
    );
  }
}
